<template>
    <div v-if="link" class="d-flex flex-wrap align-items-center pb-2">
        <div class="col-12 col-sm-6" v-if="link.home">
            <div
                @click="() => navigate('home')"
                class="d-flex align-items-center cursor-pointer mb-0"
            >
                <div class="d-flex align-items-baseline">
                    <i style="font-size: 13px" class="navigation-icon fas fa-chevron-left"></i>
                    <i class="fas fa-home"></i>
                </div>
                <h3 class="mb-0 pl-2">{{link.home.name}}</h3>
            </div>
        </div>
        <div
            class="navigation left"
            @click="navigate('prev')"
            @mouseover="showLeft = true"
            @mouseleave="showLeft = false"
        >
            <i class="navigation-icon fas fa-chevron-left"></i>
        </div>
        <div
            class="navigation right"
            @click="navigate('next')"
            @mouseover="showRight = true"
            @mouseleave="showRight = false"
        >
            <i class="navigation-icon fas fa-chevron-right"></i>
        </div>

        <FadeTransition v-if="link.prev">
            <div class="navigation label label-left" v-show="showLeft">{{link.prev.name}}</div>
        </FadeTransition>
        <FadeTransition v-if="link.next">
            <div class="navigation label label-right" v-show="showRight">{{link.next.name}}</div>
        </FadeTransition>
    </div>
</template>

<script>
// import BaseButton from "../../argon/components/BaseButton";
import { FadeTransition } from "vue2-transitions";

export default {
    name: "NavigationControl",

    components: {
        FadeTransition
    },

    props: {
        link: Object
    },

    data() {
        return {
            showLeft: false,
            showRight: false
        };
    },

    methods: {
        navigate(direction) {
            if (direction === "next") {
                const link = this.link.next.url;
                location.href = link;
            } else if (direction === "prev") {
                const link = this.link.prev.url;
                location.href = link;
            } else {
                const link = this.link.home.url;
                location.href = link;
            }
        }
    }
};
</script>

<style>
</style>
